import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const SeedLotId = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      name="seedLotId"
      placeholder="Enter seed lot ID"
      label="Seed Lot ID"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default SeedLotId;
